import { ChatMessageModel, ClarificationResponse } from '../client/SmartAssistantBackendClient';
import { normalizeMessages } from './chatMessageUtils';

export const buildRequestHistory = (params: {
  history: ChatMessageModel[];
  trimmedText: string;
  clarificationPayload?: ClarificationResponse;
  appendLocalUserMessage: boolean;
}) => {
  const { history, trimmedText, clarificationPayload, appendLocalUserMessage } = params;
  const formatClarificationContent = (clarification?: ClarificationResponse): string => {
    if (!clarification?.questions?.length) return '';
    const lines = clarification.questions.map((q, idx) => {
      const question = q?.question ?? `Frage ${idx + 1}`;
      const answer = (q?.answer ?? '').trim();
      return answer ? `- ${question}\n  Antwort: ${answer}` : `- ${question}`;
    });
    return `Klärungsfragen:\n${lines.join('\n')}`;
  };
  const userMessageContent = trimmedText || formatClarificationContent(clarificationPayload);
  const userMessage = appendLocalUserMessage
    ? ChatMessageModel.fromJS({
      role: 'user',
      content: userMessageContent,
      clarification: clarificationPayload,
    })
    : null;
  const outgoingHistory = userMessage ? [...history, userMessage] : [...history];
  const normalizedOutgoing = normalizeMessages(outgoingHistory as any);

  const requestSource = appendLocalUserMessage ? history : outgoingHistory;
  const normalizedRequest = normalizeMessages(requestSource as any);
  const requestHistory = normalizedRequest
    .filter(m => m?.role !== 'tool')
    .map((m: any) => {
      const base = typeof m?.toJSON === 'function' ? m.toJSON() : m;
      if (base?.role === 'assistant') {
        return ChatMessageModel.fromJS({
          ...base,
          toolCalls: undefined,
          toolResult: undefined,
        });
      }
      return ChatMessageModel.fromJS(base);
    });
  const cleanedRequestHistory = requestHistory.filter((m: any) => {
    if (m?.role !== 'assistant') return true;
    const content = typeof m?.content === 'string' ? m.content.trim() : '';
    const hasClarification = Boolean(m?.clarification?.questions?.length);
    const hasDownload = Boolean(m?.downloadRequest);
    return content.length > 0 || hasClarification || hasDownload;
  });
  return { userMessage, normalizedOutgoing, requestHistory: cleanedRequestHistory };
};
